export const API_BASE = 'https://workforce-api.govirtual.ph';

export const STATUS_CONFIG = {
  CHECKIN:    { label: 'Checked In',   color: '#0a9e74', bg: '#e6f9f4', border: '#b3ead9' },
  CHECKOUT:   { label: 'Checked Out',  color: '#c06000', bg: '#fff4e0', border: '#ffd599' },
  STARTBREAK: { label: 'On Break',     color: '#7b1fa2', bg: '#f5e6ff', border: '#d9b3f5' },
  ENDBREAK:   { label: 'Break Ended',  color: '#1075BA', bg: '#e6f2ff', border: '#99ccf5' },
  NA:         { label: 'No Activity',  color: '#6b7f8e', bg: '#f0f4f7', border: '#c8d4dc' },
};

export const ACTIVITY_STAGES = [
  { key: 'checkin',    label: 'Check In',    color: '#0a9e74', dotColor: '#0a9e74' },
  { key: 'startbreak', label: 'Start Break', color: '#7b1fa2', dotColor: '#7b1fa2' },
  { key: 'endbreak',   label: 'End Break',   color: '#1075BA', dotColor: '#1075BA' },
  { key: 'checkout',   label: 'Check Out',   color: '#c06000', dotColor: '#c06000' },
];

export const NET_QUALITY_CONFIG = {
  stable:   { label: 'Stable',   color: '#0a9e74' },
  moderate: { label: 'Moderate', color: '#f59e0b' },
  unstable: { label: 'Unstable', color: '#ef4444' },
  offline:  { label: 'Offline',  color: '#6b7f8e' },
  unknown:  { label: 'Unknown',  color: '#9aa8b4' },
};
